import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
type CheckItemProps = {
  children: React.ReactNode;
  variant?: 'check' | 'cross';
  className?: string;
};
export function CheckItem({
  children,
  variant = 'check',
  className = ''
}: CheckItemProps) {
  const isCheck = variant === 'check';
  return <li className={`flex items-start gap-3 ${className}`} data-id="element-22" data-mp="2c1oc6b2yhjci">
      <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${isCheck ? 'bg-gold text-black' : 'border border-red-400/50 text-red-400'}`} data-id="element-23" data-mp="2c04tyexqoy83">
        {isCheck ? <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-24" data-mp="225l82zojnamx" /> : <XIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-25" data-mp="1o5u0bgomeqhd" />}
      </span>
      <span data-id="element-26" data-mp="1t4n2we2dcx2r">{children}</span>
    </li>;
}